/* eslint-disable camelcase */
/* eslint-disable jsx-quotes */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import history from '../../history';
import routes from '../../utils/routes';

import Paginator from '../Paginator';
import Loader from '../loader-component/loader';
import ItemTest from './components/ItemTest';

import {
    asyncFetchTemplateTests,
    asyncRemoveTemplateTest,
    changeModalRemoveTemplateTest,
    changeShouldBeRefreshTemplateTests,
    asyncFecthTypeTestsToFilter,
} from './tests.actions';

import './tests.css';

class Tests extends Component {
    constructor(props) {
        super(props);

        this.state = {
            templateTests: [],
            total: 0,
            pageSize: 25,
            page: 0,
            typeTestFilter: '',
            labelName: '',
            orderBy: '',
            orderMode: '',
            statusFilter: '',
            activeId: null,
            showDescriptionStatus: false,
        };
    }

    componentDidMount() {
        const { total } = this.props;
        const {
            pageSize,
            page,
            orderBy,
            orderMode,
            typeTestFilter,
            labelName,
            statusFilter,
        } = this.state;
        this.fetchTemplateTests({
            pageSize,
            page,
            orderBy,
            orderMode,
            typeTest: typeTestFilter,
            label: labelName,
            status: statusFilter,
        });
        this.props.asyncFecthTypeTestsToFilter();
        this.setState({ total });
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            total,
            template_tests,
            shouldBeRefresh,
            changeShouldBeRefreshTemplateTests,
        } = this.props;
        const {
            page,
            pageSize,
            orderBy,
            orderMode,
            typeTestFilter,
            labelName,
            statusFilter,
        } = this.state;

        if (prevProps.total !== total) {
            this.setState({ total });
        }

        if (prevProps.template_tests !== template_tests) {
            this.setState({ templateTests: template_tests });
        }

        if (
            prevState.page !== page ||
            prevState.pageSize !== pageSize ||
            prevState.orderBy !== orderBy ||
            prevState.orderMode !== orderMode ||
            prevState.typeTestFilter !== typeTestFilter ||
            prevState.statusFilter !== statusFilter ||
            prevState.labelName !== labelName ||
            (prevProps.shouldBeRefresh !== shouldBeRefresh && shouldBeRefresh)
        ) {
            this.fetchTemplateTests({
                page,
                pageSize,
                orderBy,
                orderMode,
                typeTest: typeTestFilter,
                label: labelName,
                status: statusFilter,
            });

            if (shouldBeRefresh) {
                changeShouldBeRefreshTemplateTests(false);
            }
        }
    }

    fetchTemplateTests({
        page,
        pageSize,
        orderBy,
        orderMode,
        typeTest,
        label,
        status,
    }) {
        const { asyncFetchTemplateTests } = this.props;
        asyncFetchTemplateTests({
            page,
            pageSize,
            orderBy,
            orderMode,
            typeTest,
            label,
            status,
        });
    }

    getStatusTest({ status }) {
        switch (status) {
            case 'INCOMPLETE':
                return 'Incompleto';
            case 'READY':
                return 'Completo';
            case 'READY_WITH_COMPLETION':
                return 'Completo Respondido';
            case 'LINKED':
                return 'Vinculado';
            case 'LINKED_WITH_COMPLETION':
                return 'Vinculado Respondido';
            default:
                return 'Não identificado';
        }
    }

    goToAddTest() {
        history.push(routes.ADD_TEMPLATE_TEST);
    }

    onChangePage(newPage) {
        this.setState({ page: newPage });
    }

    onChangeRowsPerPage(newPageSize) {
        this.setState({ pageSize: newPageSize, page: 0 });
    }

    handleActiveId(newId) {
        this.setState({ activeId: newId });
    }

    getTypeTest({ type }) {
        switch (type) {
            case 'FORMACAO':
                return 'Formação';
            case 'MASTER':
                return 'Master';
            case 'UNIFICADO':
                return 'Unificado';
            default:
                return 'Não identificado';
        }
    }

    gotoBack() {
        history.push(routes.TEMPLATE_TESTS);
    }

    gotoManageQuestion(testId) {
        history.push(routes.MANAGE_TEMPLATE_TEST.replace(':test_id', testId));
    }

    gotoDuplicateQuestion(testId) {
        history.push(
            routes.DUPLICATE_TEMPLATE_TEST.replace(':test_id', testId),
        );
    }

    handlePortalRemove(currentState) {
        const { changeModalRemoveTemplateTest } = this.props;
        changeModalRemoveTemplateTest(!currentState);
    }

    handleConfirmRemove(testId) {
        const { asyncRemoveTemplateTest } = this.props;
        asyncRemoveTemplateTest({ testId });
    }

    handleShowDescriptionStatus(newShowDescriptionStatus) {
        this.setState({
            showDescriptionStatus: newShowDescriptionStatus,
        });
    }

    render() {
        const {
            templateTests,
            total,
            pageSize,
            orderBy,
            orderMode,
            typeTestFilter,
            labelName,
            statusFilter,
            activeId,
            showDescriptionStatus,
        } = this.state;
        const { loading, showModalRemoveTest, testTypesToFilter } = this.props;

        return (
            <section className="container-tests">
                <header className="header-tests">
                    <span className="content-filters">
                        <div className="field">
                            <label>Buscar testes</label>
                            <input
                                placeholder="Buscar testes"
                                className="input"
                                type="text"
                                onChange={({ target }) =>
                                    this.setState({
                                        labelName: target.value,
                                    })
                                }
                                value={labelName}
                            />
                        </div>
                        <div className="field">
                            <label>Ordenação</label>
                            <select
                                className="input"
                                onChange={({ target }) =>
                                    this.setState({ orderBy: target.value })
                                }
                                value={orderBy}
                            >
                                <option value="">Selecionar</option>
                                <option value="created_at">Criado em</option>
                                <option value="updated_at">Editado em</option>
                            </select>
                        </div>
                        <div className="field">
                            <label>Tipo da ordenação</label>
                            <select
                                className="input"
                                onChange={({ target }) =>
                                    this.setState({ orderMode: target.value })
                                }
                                value={orderMode}
                            >
                                <option value="">Selecionar</option>
                                <option value="asc">Crescente</option>
                                <option value="desc">Decrescente</option>
                            </select>
                        </div>
                        <div className="field">
                            <label>Status</label>
                            <select
                                className="input"
                                onChange={({ target }) =>
                                    this.setState({
                                        statusFilter: target.value,
                                    })
                                }
                                value={statusFilter}
                            >
                                <option value="">Selecionar</option>
                                <option value={'INCOMPLETE'}>Incompleto</option>
                                <option value={'READY'}>Completo</option>
                                <option value={'READY_WITH_COMPLETION'}>
                                    Completo Respondido
                                </option>
                                <option value={'LINKED'}>Vinculado</option>
                                <option value={'LINKED_WITH_COMPLETION'}>
                                    Vinculado Respondido
                                </option>
                            </select>
                        </div>
                        <div className="field">
                            <label>Tipo</label>
                            <select
                                className="input"
                                onChange={({ target }) =>
                                    this.setState({
                                        typeTestFilter: target.value,
                                    })
                                }
                                value={typeTestFilter}
                            >
                                <option value="">Selecionar</option>
                                {testTypesToFilter.map(type => (
                                    <option key={type.id} value={type.id}>
                                        {type.title}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </span>
                    <button
                        className="add-btn"
                        type="button"
                        onClick={this.goToAddTest}
                    >
                        Adicionar
                    </button>
                </header>
                <section className="table-grid">
                    <div className="table-grid-header">
                        <span>
                            <p>Label da prova</p>
                        </span>
                        <span>
                            <p>Tipo</p>
                        </span>
                        <span className="container-title-status">
                            <p
                                className="title-status"
                                onClick={() =>
                                    this.handleShowDescriptionStatus(
                                        !showDescriptionStatus,
                                    )
                                }
                                title="Clique para ver mais detalhes"
                            >
                                Status <i className="fa fa-info-circle" />
                            </p>
                            {showDescriptionStatus && (
                                <span className="container-info">
                                    <span
                                        className="background-info"
                                        onClick={() =>
                                            this.handleShowDescriptionStatus(
                                                !showDescriptionStatus,
                                            )
                                        }
                                    ></span>
                                    <span className="content-info">
                                        <span className="header-info">
                                            <h1>Informações</h1>
                                            <i
                                                className="fa fa-times-circle icon"
                                                onClick={() =>
                                                    this.handleShowDescriptionStatus(
                                                        !showDescriptionStatus,
                                                    )
                                                }
                                            />
                                        </span>
                                        <p>
                                            <strong>Incompleto:</strong> Teste
                                            não possui a quantidade mínima de
                                            questões válidas, nesse status o
                                            teste não poderá ser vinculado a
                                            nenhuma turma;
                                        </p>
                                        <p>
                                            <strong>Completo:</strong> Teste
                                            possui a quantidade mínima de
                                            questões válidas mas ainda não
                                            possui vínculo com nenhuma turma;
                                        </p>
                                        <p>
                                            <strong>
                                                Completo Respondido:
                                            </strong>{' '}
                                            Teste possui a quantidade mínima de
                                            questões e já foi respondido pelo
                                            menos uma vez, no entanto, no
                                            momento não está vinculado a nenhuma
                                            turma;
                                        </p>
                                        <p>
                                            <strong>Vinculado:</strong> Teste
                                            possui a quantidade mínima de
                                            questões e possui vínculo com pelo
                                            menos uma turma, no entanto, ainda
                                            não foi respondida nenhuma vez;
                                        </p>
                                        <p>
                                            <strong>
                                                Vinculado Respondido:
                                            </strong>{' '}
                                            Teste possui a quantidade mínima de
                                            questões, possui vínculo com pelo
                                            menos uma turma, já foi respondida
                                            pelo menos uma vez;
                                        </p>
                                    </span>
                                </span>
                            )}
                        </span>
                        <span>
                            <p>Quant. de questões</p>
                        </span>
                        <span>
                            <p>Porc. para aprovação</p>
                        </span>
                        <span>
                            <p>Criado em</p>
                        </span>
                        <span>
                            <p>Editado em</p>
                        </span>
                        <span>
                            <p>Ações</p>
                        </span>
                    </div>
                    {templateTests &&
                        templateTests.length > 0 &&
                        templateTests.map(test => (
                            <ItemTest
                                key={test.id}
                                test={test}
                                showModalRemoveTest={showModalRemoveTest}
                                activeId={activeId}
                                handlePortalRemove={this.handlePortalRemove.bind(
                                    this,
                                )}
                                handleConfirmRemove={this.handleConfirmRemove.bind(
                                    this,
                                )}
                                gotoManageQuestion={this.gotoManageQuestion.bind(
                                    this,
                                )}
                                handleActiveId={this.handleActiveId.bind(this)}
                                gotoDuplicateQuestion={this.gotoDuplicateQuestion.bind(
                                    this,
                                )}
                            />
                        ))}
                </section>
                {templateTests.length === 0 && (
                    <p className="not-found-tests">Testes não encontrados</p>
                )}
                <Paginator
                    totalRows={total}
                    onChangePage={this.onChangePage.bind(this)}
                    onChangeRowsPerPage={this.onChangeRowsPerPage.bind(this)}
                    rowsPerPage={Number(pageSize)}
                />
                {loading > 0 && (
                    <Loader
                        show={loading > 0 ? true : false}
                        message={'Carregando, por favor aguarde...'}
                    />
                )}
            </section>
        );
    }
}

const mapStateToProps = ({ tests, onlineTests }) => ({
    template_tests: tests.template_tests,
    total: tests.total,
    loading: onlineTests.loading,
    showModalRemoveTest: tests.showModalRemoveTest,
    shouldBeRefresh: tests.shouldBeRefresh,
    testTypesToFilter: tests.testTypesToFilter,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            asyncFetchTemplateTests,
            asyncRemoveTemplateTest,
            changeModalRemoveTemplateTest,
            changeShouldBeRefreshTemplateTests,
            asyncFecthTypeTestsToFilter,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(Tests);



// WEBPACK FOOTER //
// ./src/components/tests/tests.js